<div class="alert alert-danger" *ngIf="showResult">

</div>
<form [formGroup]="formGroup" (validSubmit)="login()">
  <div class="form-group mb-3">
    <label class="form-label">{{"Username" | translate}}</label>
    <input type="text" class="form-control no-validation-icon no-success-validation" formControlName="email">
  </div>
  <div class="mb-3 ">
    <label class="form-label d-flex justify-content-between">
      <span>Password</span>

    </label>
    <div class="form-group input-affix flex-column">
      <label class="d-none">{{"Password" | translate}}</label>
      <input [type]="showPassword ? 'text' : 'password'"
             class="form-control no-validation-icon no-success-validation" formControlName="password">
      <i class="suffix-icon feather cursor-pointer text-dark"
         [ngClass]="showPassword ? 'icon-eye-off' : 'icon-eye'" (click)="onShowPasswordClick()">
      </i>
      <a [routerLink]="['/forgotpassword']" class="text-primary font mt-2" href="">{{"Forget Password?" |
        translate}}</a>
    </div>
  </div>
  <button class="btn btn-primary w-100" type="submit">
        <span *ngIf="!loading">
            {{"Log In" | translate}}
        </span>

    <div *ngIf="loading">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </button>
</form>
<div *ngIf="thirPartyLogin">
  <div class="divider">
    <span class="divider-text text-muted">or login with</span>
  </div>
  <div class="row">
    <div class="col px-1">
      <button class="btn btn-outline-secondary w-100">
        <img src="/assets/images/thumbs/thumb-1.png" alt="" style="max-width: 20px;">
      </button>
    </div>
    <div class="col px-1">
      <button class="btn btn-outline-secondary w-100">
        <img src="/assets/images/thumbs/thumb-2.png" alt="" style="max-width: 20px;">
      </button>
    </div>
    <div class="col px-1">
      <button class="btn btn-outline-secondary w-100">
        <img src="/assets/images/thumbs/thumb-3.png" alt="" style="max-width: 20px;">
      </button>
    </div>
  </div>
</div>
